
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.5355 12.9497C11.926 13.3403 12.5591 13.3403 12.9497 12.9497C13.3402 12.5592 13.3402 11.9261 12.9497 11.5355L9.41413 8L12.9497 4.46447C13.3402 4.07394 13.3402 3.44078 12.9497 3.05025C12.5591 2.65973 11.926 2.65973 11.5355 3.05025L7.99992 6.58579L4.46439 3.05025C4.07386 2.65973 3.4407 2.65973 3.05017 3.05025C2.65965 3.44078 2.65965 4.07394 3.05017 4.46447L6.58571 8L3.05017 11.5355C2.65965 11.9261 2.65965 12.5592 3.05017 12.9497C3.4407 13.3403 4.07386 13.3403 4.46438 12.9497L7.99992 9.41421L11.5355 12.9497Z","fill":"#10001F"}})])
          )
        }
      }
    